var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Copy, Optional } from '@honda-canada/design-system-react';
import { HOUR_SEPARATOR } from './utils/constants';
var DealerHours = function (_a) {
    var isDealerOpen = _a.isDealerOpen, message = _a.message, isHoursUnavailable = _a.isHoursUnavailable, rest = __rest(_a, ["isDealerOpen", "message", "isHoursUnavailable"]);
    var t = useTranslation().t;
    var dealerStatus = isDealerOpen ? t('Shared.Common.openLabel') : t('Shared.Common.closedLabel');
    return (React.createElement(Copy, __assign({ size: "extraSmall", color: "white" }, rest),
        React.createElement(Optional, { when: isDealerOpen },
            React.createElement("span", { "data-testid": "cy-dealer-hours-status" }, dealerStatus), " ".concat(HOUR_SEPARATOR, " "),
            React.createElement("span", { "data-testid": "cy-dealer-hours-message" }, message)),
        React.createElement(Optional, { when: isHoursUnavailable },
            React.createElement("span", { "data-testid": "cy-dealer-hours-message" }, message))));
};
export default DealerHours;
